import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import styles from './LoginForm.module.scss';
import LoginInput from 'component/atom/forms/login-components/input/LoginInput';
import LoginButton from 'component/atom/forms/login-components/button/LoginButton';

import { usePost } from 'hooks/usePost';
import { authenticationEndpoints } from 'hooks/endpoints';
import { useToast } from 'app-context/toasterContext/ToastContext';

const mail = 'src/svg/vectors/mail.svg';
const lock = 'src/svg/vectors/lock.svg';
const aiDucatorLogo = 'src/svg/sidebar/logo.svg';
const validationSchema = Yup.object({
  username: Yup.string().required('Username is required'),
  password: Yup.string()
    .min(6, 'Minimum 6 characters')
    .required('Password is required'),
});
const initialValues = {
  username: '',
  password: '',
};
const LoginForm = ({ onForgotPassword }) => {
  const { mutate: login, isPending } = usePost({
    onErrorToast: 'Invalid Credentials',
  });

  const toast = useToast();
  const handleSubmit = (values, actions) => {
    actions.setStatus(null);

    const fields = {
      username: values.username,
      password: values.password,
    };

    login(
      {
        url: authenticationEndpoints.login(),
        data: fields,
        requireAuth: false,
      },
      {
        onSuccess: (res) => {
          localStorage.setItem('token', JSON.stringify(res.data.token));
          localStorage.setItem('AIDucator_userId', res.data.userId);

          const token = localStorage.getItem('token');
          const userId = localStorage.getItem('AIDucator_userId');

          if (token && userId) {
            window.location.reload();
          } else {
            toast.open({
              message: 'Login failed. Please try again.',
              type: 'error',
            });
          }
        },
        onError: (err) => {
          actions.setStatus(
            err?.response?.data?.message || 'Invalid Credentials',
          );
        },
      },
    );
  };
  const formik = useFormik({
    initialValues: initialValues,
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      handleSubmit(values, actions);
    },
  });

  const handleForgot = () => {
    if (onForgotPassword) return onForgotPassword();
    console.log('Forgot password clicked');
  };
  return (
    <div className={styles.card}>
      <div className={styles.logoRow}>
        <img src={aiDucatorLogo} alt='' />
      </div>

      <div className={styles.welcomeMsg}>
        <h1 className={styles.title}>Welcome back</h1>
        <p className={styles.desc}>
          Enter your credentials to access your account.
        </p>
      </div>
      <form className={styles.form} onSubmit={formik.handleSubmit}>
        <LoginInput
          formik={formik}
          name='username'
          label='Email'
          placeholder='Enter your email'
          autoComplete='username'
          svg={mail}
        />

        <LoginInput
          formik={formik}
          name='password'
          label='Password'
          type='password'
          placeholder='Enter your password'
          autoComplete='current-password'
          actionLabel='Forgot password?'
          onActionClick={handleForgot}
          svg={lock}
        />

        <LoginButton
          label='Sign in to your account'
          disabled={isPending}
          isLoading={isPending}
        />

        {/* <p className={styles.footer}>
          By continuing, you agree to our <span>Terms of Service</span> and{' '}
          <span>Privacy Policy</span>.
        </p> */}
      </form>
    </div>
  );
};

export default LoginForm;
